exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.jumbotron1 {\n    margin: 80px auto;\n    padding: 2%; \n    display: block;\n    text-align: center;\n}\n\n.button{ \n   padding: 24px;\n   line-height: 123px; \n   width: 100%;\n   background-color:#d1251f;\n   color: #FFFFFF;\n   text-decoration: none;\n}\n\n.text{\n    font-size:24px;\n    font-family: 'Tangerine';\n    font-weight: bold;\n    font-style: normal;\n}\na {\n    color: #337ab7;\n    text-decoration: none !important;\n}\n\n.jumbotron {\n    margin: 20px -13px;\n    padding: 2%; \n    background-color:#FFFFFF;   \n    display: block;\n    border:1px #34495e solid;\n    border-radius: 0px;\n    height: 100px;\n    text-align: left;\n}\n.jumbotron2 {\n    margin: 20px -13px;\n    padding: 2%; \n    background-color:#FFFFFF;   \n    display: block;\n    border:1px #34495e solid;\n    border-radius: 0px;\n    margin-top:0px;\n}\n.containerbackground{\n    background:#e8e8e8;\n    width: 100%;\n    margin: 0 auto;\n    min-height: calc(100vh - 0px);\n    background-size: cover;\n    text-align: center;\n    padding-left: 0px;\n    padding-right: 0px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/technicalservice/components/home-technicalservice/home-technicalservice.component.css
// module id = 1084
// module chunks = 0